module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/lizard_BW-p-1080-51cbb9cc415ce3ee88a5ba4da5913b4e.jpg";